import { intensityLevels } from '../../utils/functions/getRowColorStations';
import './RainfallTable.css';
export function Legend() {
  return (
    <div className="mt-4">
      <h6 className="mb-2">Intensidade da Chuva:</h6>
      <div className="rainfall-legend">
        {intensityLevels.map((level) => (
          <span key={level.label} className="legend-pill">
            <span
              className="legend-dot"
              style={{ backgroundColor: level.color }}
            />
            {level.label}
          </span>
        ))}
      </div>
    </div>
  );
}
